module.exports = __webpack_public_path__ + "static/media/pattern.dd5652d6.png";